import { Company } from "../store/ducks/companies.ducks"

export function sortCompaniesAlphabetically(
  companies: Company[],
  asc: boolean
) {
  const sortedCompanies = companies.sort((a, b) => {
    const displayNameA = a?.user_company_name || a?.name
    const displayNameB = b?.user_company_name || b?.name

    return asc
      ? displayNameA.localeCompare(displayNameB)
      : displayNameB.localeCompare(displayNameA)
  })

  return sortedCompanies
}

export function sortCompaniesByClientsCount(
  companies: Company[],
  asc: boolean
) {
  return companies.sort((a, b) =>
    asc
      ? (a?.customer_count ? a?.customer_count : 0) -
        (b?.customer_count ? b?.customer_count : 0)
      : (b?.customer_count ? b?.customer_count : 0) -
        (a?.customer_count ? a?.customer_count : 0)
  )
}

export function sortCompaniesByCollaboratorsCount(
  companies: Company[],
  asc: boolean
) {
  return companies.sort((a, b) =>
    asc
      ? (a?.collaborator_count ? a?.collaborator_count : 0) -
        (b?.collaborator_count ? b?.collaborator_count : 0)
      : (b?.collaborator_count ? b?.collaborator_count : 0) -
        (a?.collaborator_count ? a?.collaborator_count : 0)
  )
}

export const sortCompaniesByFavorite = (companies: Company[]) => {
  return [
    ...companies.sort((a, b) => (a.is_favorite && !b.is_favorite ? -1 : 1)),
  ]
}

export const sortCompaniesByFavoriteAndName = (
  companies: Company[],
  asc: boolean
) => {
  let sorted = sortCompaniesAlphabetically(companies, asc)

  sorted = [
    ...sorted.sort((a, b) =>
      asc
        ? a.is_favorite && !b.is_favorite
          ? -1
          : 1
        : a.is_favorite && !b.is_favorite
        ? 1
        : -1
    ),
  ]

  return sorted
}

export function sortCompaniesByWritingsToDownloadOrGenerate(
  companies: Company[],
  asc: boolean
) {
  const readyToDownloadAndGenerate = companies.filter(
    (c) => c.readyToDownload && c.readyToGenerate
  )
  const readyToDownload = companies.filter(
    (c) => c.readyToDownload && !c.readyToGenerate
  )
  const readyToGenerate = companies.filter(
    (c) => c.readyToGenerate && !c.readyToDownload
  )
  const notReady = companies.filter(
    (c) => !c.readyToGenerate && !c.readyToDownload
  )

  const allCompanies: Company[] = [
    ...sortReadyToDownload(readyToDownloadAndGenerate),
    ...sortReadyToDownload(readyToDownload),
    ...sortReadyToGenerate(readyToGenerate),
    ...sortCompaniesAlphabetically(notReady, asc),
  ]

  return asc ? allCompanies : allCompanies.reverse()
}

export const sortReadyToDownload = (companies: Company[]) => {
  return companies.sort(
    (a, b) =>
      (b?.readyToDownload ? b?.readyToDownload : 0) -
      (a?.readyToDownload ? a?.readyToDownload : 0)
  )
}

export const sortReadyToGenerate = (companies: Company[]) => {
  return companies.sort((a, b) => {
    const aVal = a?.readyToGenerate === true ? 1 : 0
    const bVal = b?.readyToGenerate === true ? 1 : 0
    return bVal - aVal
  })
}

export function filterCompanies(companies: Company[], search: string) {
  if (!search) {
    return companies
  }

  return companies.filter((company) =>
    company?.user_company_name
      ? company?.user_company_name?.toLowerCase().includes(search.toLowerCase())
      : company?.name.toLowerCase().includes(search.toLowerCase()) ||
        company.accounting_software_reference
          ?.toLowerCase()
          .includes(search.toLowerCase())
  )
}
